export enum RugbyUnionTackleAttribute {
  Dominant = 2986,
  TrySaving = 2987,
}
